<template>
  <div class="avue-top flex-start">
    <div class="top-bar__right">
      <div class="margin-right-40">
        <div class="flex-center flex-col pointer" @click="gohelpPage">
          <img src="@/static/icon_top_help.png" alt="" style="width: 22px; height: 22px" />
          <span class="color-666 font-12">帮助中心</span>
        </div>
      </div>
      <div class="margin-right-40">
        <top-notice />
      </div>
      <div class="flex-center margin-right-40">
        <top-lock />
      </div>
      <div class="flex-center margin-right-40">
        <div class="flex-center flex-col pointer" @click="handleScreen">
          <img
            v-if="isFullScren"
            src="@/static/icon_top_nofull.png"
            alt=""
            style="width: 22px; height: 22px"
          />
          <img v-else src="@/static/icon_top_full.png" alt="" style="width: 22px; height: 22px" />
          <span class="color-666 font-12">全屏</span>
        </div>
      </div>
      <img v-if="userInfo.avatar" :src="userInfo.avatar" class="top-bar__img" />
      <img v-else src="@/static/login/avatar-small.png" class="top-bar__img" />
      <el-dropdown>
        <span class="el-dropdown-link color-333">
          {{ userInfo.username }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link to="/">{{ $t('navbar.dashboard') }}</router-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <router-link to="/user/profile">{{ $t('navbar.userinfo') }}</router-link>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout" divided>{{
            $t('navbar.logOut')
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { fullscreenToggel, listenfullscreen } from '@/util/util'
  import topLock from './top-lock'
  import topNotice from './top-notice'
  export default {
    components: {
      topLock,
      topNotice
    },
    name: 'top',
    data() {
      return {}
    },
    filters: {},
    created() {},
    mounted() {
      listenfullscreen(this.setScreen)
    },
    computed: {
      ...mapGetters([
        'setting',
        'userInfo',
        'isFullScren',
        'tagWel',
        'tagList',
        'isCollapse',
        'tag',
        'logsLen',
        'logsFlag',
        'isHorizontal'
      ])
    },
    methods: {
      handleScreen() {
        fullscreenToggel()
      },
      setCollapse() {
        this.$store.commit('SET_COLLAPSE')
      },
      setScreen() {
        this.$store.commit('SET_FULLSCREN')
      },
      logout() {
        this.$confirm(this.$t('logoutTip'), this.$t('tip'), {
          confirmButtonText: this.$t('submitText'),
          cancelButtonText: this.$t('cancelText'),
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('LogOut').then(() => {
            this.$store.commit('SET_USERIFNO', {})
            this.$router.push({ path: '/login' })
            window.location.reload()
          })
        })
      },
      gohelpPage() {
        const item = {
          label: '首页',
          path: '/home/index',
          icon: 'el-icon-document',
          meta: {
            i18n: 'dashboard',
            permission: '*'
          },
          parentId: 0
        }
        this.goPage(item)
      },
      goPage(item) {
        this.$router.push({
          path: this.$router.$avueRouter.getPath({
            name: item.label,
            src: item.path,
            i18n: item.meta.i18n
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
